/**
 * VIDEO_HLS 调试日志采集：劫持 console.log/warn/error，遇到 [VIDEO_HLS] 前缀自动追加到本地文件。
 * 文件路径：Electron 用户数据目录下的 video-hls-debug.log（启动时由 background.js 清空）。
 */
const PREFIX = '[VIDEO_HLS]'

function serializeArg(a) {
  if (a instanceof Error) return a.stack || a.message || String(a)
  if (typeof a === 'object' && a !== null) {
    try { return JSON.stringify(a) } catch (e) { return String(a) }
  }
  return String(a)
}

export function installVideoHlsLogger() {
  if (!window.electronAPI || !window.electronAPI.invoke) return
  const origLog = console.log.bind(console)
  const origWarn = console.warn.bind(console)
  const origErr = console.error.bind(console)

  const write = (level, args) => {
    try {
      const first = args && args[0]
      if (typeof first !== 'string' || first.indexOf(PREFIX) === -1) return
      const ts = new Date().toISOString()
      const line = `[${ts}][${level}] ` + args.map(serializeArg).join(' ') + '\n'
      window.electronAPI.invoke('append-video-hls-log', line)
    } catch (e) { /* ignore */ }
  }

  console.log = function (...args) { origLog(...args); write('LOG', args) }
  console.warn = function (...args) { origWarn(...args); write('WARN', args) }
  console.error = function (...args) { origErr(...args); write('ERROR', args) }

  // 提供全局导出方法给用户触发
  window.openVideoHlsLog = () => window.electronAPI.invoke('open-video-hls-log')
  window.getVideoHlsLogPath = () => window.electronAPI.invoke('get-video-hls-log-path')
}
